import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

interface IDayProps {
  isInMonth: boolean;
  isActive: boolean;
}

export const Day = styled(Box)<IDayProps>(({ theme, isInMonth, isActive }) => ({
  width: "100%",
  height: "100%",
  aspectRatio: "1",
  borderRadius: theme.spacing(0.8),
  backgroundColor: isInMonth ? (isActive ? theme.palette.dsGreen?.v200 : theme.palette.dsSurface.v300) : "transparent",
  border: isInMonth ? "none" : "1px solid transparent",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    transform: "scale(1.05)",
    boxShadow: isActive ? "0 2px 8px rgba(0,0,0,0.15)" : "none",
  },
}));
